<template>
  <IconLucideCompass />
</template>
